import { TokenService } from "@/api/storage.js";
import { mapActions } from "vuex";
import _ from "lodash";
export default {
  data: () => ({
    disabledOffice: false
  }),
  methods: {
    checkUserType() {
      return TokenService.getTypeUser() == "escritorio";
    },
    ...mapActions("quotation", ["requestOfficeByEconomicGroup"]),
    fetchOfficeQuotation() {
      this.withLoading(
        this.requestOfficeByEconomicGroup(this.form.tomador.grupo.id)
      ).then(() => {
        this.updateOffice();
      });
    },
    updateOffice() {
      // Atualizar apenas se não tiver valor
      // pré-setado
      if (this.form.escritorio) return;
      this.disabledOffice = this.checkUserType();
      const officeOnIndex = this.checkUserType() ? _.head : _.last;
      this.form.escritorio = officeOnIndex(this.listOfficeQuotation);
    }
  }
};
